import React from "react"
import { FiLinkedin } from "react-icons/fi"

import { Mark } from "./mark"

const Footer = () => (
  <footer className="site-footer">
    <div className="site-footer__inner">
      <div className="site-footer__about">
        <div className="brand brand--footer">
          <Mark className="brand__mark" />
          <span className="brand__name">Euroweb</span>
        </div>
        <p>
          Euroweb B.V. is a software engineering and consulting firm. We help
          entrepreneurs and companies with product development and the technical
          side of their business.
        </p>
      </div>
      <address className="site-footer__legal">
        <span>Haarlemmerweg 331A, 1051 LH Amsterdam, The Netherlands</span>
        <span>KvK 81944756</span>
      </address>
      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} Euroweb B.V. All rights reserved.</span>
        <a
          href="https://www.linkedin.com/company/euroweb-bv"
          className="icon-link"
          aria-label="Euroweb on LinkedIn"
        >
          <FiLinkedin aria-hidden="true" />
        </a>
      </div>
    </div>
  </footer>
)

export default Footer
